import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AnalyticsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AnalyticsSVG;
